<div id="main" class="internal">
  <div id="home" class="section home-prenotazioni">
    <div class="content-body">
      <div class="big-button" (click)="goTo('extraction')">
        <div class="img-button">
          <div class="icon">
            <i class="pi pi-download" style="font-size: 2.5rem"></i>
          </div>
        </div>
        <button class="costa-button">
          {{ "reservations_home.extraction" | translate }}
        </button>
      </div>

      <div class="big-button" (click)="goTo('administration')">
        <div class="img-button">
          <div class="icon">
            <i class="pi pi-user-edit" style="font-size: 2.5rem"></i>
          </div>
        </div>
        <button class="costa-button">
          {{ "reservations_home.administration" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
